import styled from "styled-components";

export const HomeContainer = styled.div``;

export const HomeSidebar = styled.div``;

export const HomeSidebarWrapper = styled.div`
  width: 100%;
  margin-bottom: 1rem;
  padding: 8px;

  /* Remove and use in main parent */
  p {
    margin: unset;
  }
`;

export const HomeTitle = styled.div`
  color: #333333;
  font-size: 25px;
  font-weight: 700;
  text-transform: capitalize;
  margin-bottom: 1rem;
`;

export const ViewAll = styled.div`
  color: #4f4f4f;
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  margin: 0.5rem 0 1rem 0;
  float: right;

  &:hover {
    cursor: pointer;
    color: #2a71d4;
  }
`;
